import { useQuery } from '@tanstack/react-query';

import { getSampleByQreIdOperationsOptions } from '../../api/generated-evs/@tanstack/react-query.gen';

import type { Operation } from './types';

export const useRunningOperations = (qreId: string, enabled = true) => {
  const apiQuery = useQuery({
    ...getSampleByQreIdOperationsOptions({ path: { qreId } }),
    enabled: enabled,
    refetchInterval: 3000,
    refetchIntervalInBackground: false,
    select: (data) => ({
      operations: (data?.runningOperations || []) as Operation[],
    }),
  });

  return apiQuery;
};
